import { Box, Divider, IconButton, Menu } from '@mui/material'
import { MouseEvent, useState } from 'react'
import { useAuth, useTenantsState } from '@frontegg/react'

import { API_KEY_METADATA_KEY } from 'src/constants'
import LoginMenuItem from './LoginMenuItem'
import LogoutMenuItem from './LogoutMenuItem'
import MenuIcon from '@mui/icons-material/Menu'
import MigrationGuideMenuItem from './MigrationGuideMenuItem'
import ShowAdminMenuItem from './ShowAdminMenuItem'
import ShowApiKeyMenuItem from './ShowApiKeyMenuItem'
import UserInfo from '../UserInfo'

const ProfileMenu = () => {
  const { isAuthenticated } = useAuth()
  const tenantsState = useTenantsState()
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

  const showApiKeysMenu = JSON.parse(tenantsState?.activeTenant?.metadata || '{}')[
    API_KEY_METADATA_KEY
  ]

  const handleMenu = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <Box>
      <IconButton
        size="large"
        aria-label="account of current user"
        aria-controls="menu-appbar"
        aria-haspopup="true"
        onClick={handleMenu}
        color="inherit"
        sx={{
          p: 0.8,
          border: '1.5px solid rgba(255,255,255, 0.2)',
          borderRadius: '25px'
        }}
        data-testid="profile-button"
      >
        <MenuIcon fontSize="medium" />
      </IconButton>
      <Menu
        id="menu-appbar"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {isAuthenticated
          ? [
              <UserInfo key="user-info" />,
              <ShowAdminMenuItem handleClose={handleClose} key="show-admin" />,
              ...(showApiKeysMenu
                ? [<ShowApiKeyMenuItem handleClose={handleClose} key="show-api-key" />]
                : []),
              <Divider key="divider-1" />,
              <LogoutMenuItem handleClose={handleClose} key="logout" />
            ]
          : [<Divider key="divider-2" />, <LoginMenuItem handleClose={handleClose} key="login" />]}
      </Menu>
    </Box>
  )
}

export default ProfileMenu
